// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"ffde8927","233":"9ee23fa4","369":"badffd0d","936":"25eb7461"}[chunkId] + ".css";
};